import { render, staticRenderFns } from "./RepatForm.vue?vue&type=template&id=274f10c8&scoped=true&"
import script from "./RepatForm.vue?vue&type=script&lang=js&"
export * from "./RepatForm.vue?vue&type=script&lang=js&"
import style0 from "./RepatForm.vue?vue&type=style&index=0&id=274f10c8&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274f10c8",
  null
  
)

export default component.exports